import '../css/app.scss';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

import ScrollTrigger from 'gsap/ScrollTrigger';

import IntroAnimation from './components/intro-animation';

/** Pages */
import Standard from './pages/standard';

// Deaktiviert die automatische Scroll-Wiederherstellung des Browsers
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

$(() => {
	const $introAnimation = $('[data-intro-animation="el"]');

	if ($introAnimation.length) {
		new IntroAnimation($introAnimation);
	}

	barba.use(barbaPrefetch);

	barba.init({
		debug: false,
		timeout: 30000,
		views: [Standard],
		prevent: ({ el, href }) => {
			el.hasAttribute('data-anchor-nav');
			const rawHref = el.getAttribute('href') || '';
			const url = new URL(href, window.location.href);
			const isSamePageAnchor =
				url.pathname === window.location.pathname &&
				url.search === window.location.search &&
				url.hash !== '';

			return (
				rawHref.startsWith('#') ||                    // reiner Anker
				isSamePageAnchor ||                           // Anker auf gleicher Seite
				href === window.location.href ||              // gleiche Seite
				url.origin !== window.location.origin ||      // externer Link
				/^(mailto|tel):/i.test(rawHref) ||            // Mail / Telefon
				el.hasAttribute('download') ||                // Downloads
				(el.target && el.target !== '_self') ||       // neues Fenster
				/\.(pdf|zip|jpe?g|png|gif|svg|webp|mp4|mov)$/i.test(url.pathname) // Dateien
			);
		},
		transitions: [
			{
				leave() {},
				enter() {},
				after() {
					// Layout nach dem Seitenwechsel neu berechnen
					ScrollTrigger.refresh();
				},
			},
		],
	});

	$('html').addClass('initted');
});
